import Notifier from 'common/helpers/Notifier';
import { useInvalidateQueries, useUpdateRecord } from './APIHooks';

export const useDeleteInteraction = (mutationConfig = {}) => {
  const invalidateQueries = useInvalidateQueries();

  return useUpdateRecord('interaction', {
    mutationConfig: {
      onError: () => {
        Notifier.dispatch('error', 'Failed to delete interaction...');
      },
      onSettled: () => {
        invalidateQueries('interaction');
      },
      ...mutationConfig,
    },
  });
};
